import { useState } from 'react'
import CustomInput from "Utills/CustomInput/CustomInput"
import CalendarIcon from "assets/Images/icons/Calendar.svg"
import CustomModel from "Utills/Model/CustomModel"
import { Calendar } from "react-date-range";
import ReactFlagsSelect from 'react-flags-select';
import Moment from 'moment';
import { getRelatedCountry } from "config/CountriesList"

//===================  THIS IS PROFILE UPDATE FORM COMPONENT ==============================================================
const ProfileUpdateForm = ({ data, setData, handlePersonalForm, handlePasswordForm, passwordData, submitProfileUpdate }) => {
    // calendar modal state
    const [openCalendar, setOpenCalendar] = useState(false);

    // ============== age validity =======================
    // function underAgeValidate(birthday) {
    //     // it will accept two types of format yyyy-mm-dd and yyyy/mm/dd
    //     var optimizedBirthday = birthday?.toString()?.replace(/-/g, "/");

    //     //set date based on birthday at 01:00:00 hours GMT+0100 (CET)
    //     var myBirthday = new Date(optimizedBirthday);

    //     // set current day on 01:00:00 hours GMT+0100 (CET)
    //     var currentDate = new Date().toJSON().slice(0, 10) + ' 01:00:00';

    //     // calculate age comparing current date and borthday
    //     var myAge = ~~((Date.now(currentDate) - myBirthday) / (31557600000));

    //     if (myAge < 18) {
    //         return false;
    //     } else {
    //         return true;
    //     }

    // };

    // test valid date
    Date.prototype.isValid = function () {
        // An invalid date object returns NaN for getTime() and NaN is the only
        // object not strictly equal to itself.
        return this.getTime() === this.getTime();
    };

    // get valid date 
    const getValid = (d) => {
        if (new Date(d).isValid()) {
            return new Date(d)
        } else {
            return new Date()
        }

    }
    // 
    return (
        <>
            <div className="row m-0 pt-lg-0 pt-2">
                {/*================  personal info Form ======================= */}
                <div className="col-lg-7 col-12 px-lg-0 px-3 mb-3">
                    <h4 className="text-muted mb-4">Personal Information</h4>
                    <form action="" className="w-100" onSubmit={(e) => { e.preventDefault() }}>
                        <div className="row m-0">
                            <div className="col-md-6 main-input d-flex my-1 justify-content-start align-items-center">
                                <div className="profile-labels mb-auto mt-2"><label htmlFor="">First Name</label></div>
                                <div className="profile-inputs-wrapper">
                                    <CustomInput name="first_name" blueborder={"true"} placeholder="First Name" onChange={(e) => handlePersonalForm(e)} value={data.first_name} />
                                </div>
                            </div>
                            <div className="col-md-6 main-input d-flex my-1 justify-content-start align-items-center">
                                <div className="profile-labels not-lab mb-auto mt-2"><label htmlFor="">Last Name</label></div>
                                <div className="profile-inputs-wrapper">
                                    <CustomInput name="last_name" blueborder={"true"} placeholder="Last Name" onChange={(e) => handlePersonalForm(e)} value={data.last_name} />
                                </div>
                            </div>
                            <div className="col-12 main-input d-flex my-1 justify-content-start flex-sm-nowrap flex-wrap align-items-center">
                                <div className="profile-labels mb-auto mt-2"><label htmlFor="">Nationality</label></div>
                                <div className="profile-inputs-wrapper">
                                    <ReactFlagsSelect
                                        searchable
                                        className="cs_select"
                                        searchPlaceholder="Search country"
                                        placeholder="Choose nationality"
                                        selected={getRelatedCountry(data.nationality)?.iso2 || ""}
                                        onSelect={code => setData({
                                            ...data,
                                            nationality: code
                                        })}
                                    />
                                </div>
                            </div>
                            <div className="col-12 main-input d-flex my-1 justify-content-start align-items-center">
                                <div className="profile-labels mb-auto mt-2"><label htmlFor="">Email</label></div>
                                <div className="profile-inputs-wrapper">
                                    <CustomInput readOnly name="email" blueborder={"true"} placeholder="Email" onChange={(e) => handlePersonalForm(e)} value={data.email} />
                                </div>
                            </div>
                            <div className="col-12 main-input d-flex my-1 justify-content-start align-items-center">
                                <div className="profile-labels mb-auto mt-2"><label htmlFor="">Phone Number</label></div>
                                <div className="profile-inputs-wrapper">
                                    <CustomInput
                                        name="phone"
                                        blueborder={"true"}
                                        placeholder="Phone"
                                        type="number"
                                        onChange={(e) => handlePersonalForm(e)}
                                        value={data.phone}
                                    />
                                </div>
                            </div>
                            <div className="col-12 main-input d-flex my-1 justify-content-start align-items-center">
                                <div className="profile-labels mb-auto mt-2"><label htmlFor="">Date of Birth</label></div>
                                <div className="profile-inputs-wrapper">
                                    <CustomInput
                                        blueborder={"true"}
                                        // onClick={() => setOpenCalendar(prev => !prev)}
                                        readOnly
                                        start_icon={<img
                                            // onClick={() => setOpenCalendar(prev => !prev)}
                                            src={CalendarIcon} alt="" />}
                                        type="text"
                                        name="birthdate"
                                        value={Moment(data?.birthdate || "").format("YYYY-MM-DD")}
                                        placeholder="Date of Birth"
                                    />
                                    {/* age validator msg */}
                                    {/* {data?.birthdate?.toString()?.length > 0 &&
                                        !underAgeValidate(data.birthdate) &&
                                        <span className="text-danger text-left mb-2 d-block">Age should be 18 or greater.</span>
                                    } */}
                                </div>
                            </div>
                            <div className="col-12 main-input d-flex mt-4 justify-content-start align-items-center">
                                <div className="profile-labels mb-auto mt-2 d-sm-block d-none"><label htmlFor=""></label></div>
                                <button onClick={submitProfileUpdate} className="dark-btn w-100">Update & Save</button>
                            </div>
                        </div>

                    </form>
                </div>
                {/*======================== password FORm ======================= */}
                <div className="col-lg-5  col-12 main-input px-lg-2 px-4">
                    <form action="" onSubmit={(e) => { e.preventDefault() }}>
                        <div className="row pt-md-5 pt-2">
                            <h5 className="text-muted text-center mt-auto mb-4">Change Password</h5>
                            <div className="col-12 d-flex my-1 justify-content-start align-items-center">
                                <div className="profile-labels mb-auto mt-2"><label htmlFor="">Current</label></div>
                                <div className="profile-inputs-wrapper">
                                    <CustomInput readOnly blueborder={"true"} placeholder="Enter your current password" value={passwordData?.current_password} name="current_password" onChange={(e) => handlePasswordForm(e)} />
                                </div>
                            </div> <div className="col-12 main-input d-flex my-1 justify-content-start align-items-center">
                                <div className="profile-labels mb-auto mt-2"><label htmlFor="">New</label></div>
                                <div className="profile-inputs-wrapper">
                                    <CustomInput blueborder={"true"} placeholder="Enter new password" value={passwordData?.new_password} name="new_password" onChange={(e) => handlePasswordForm(e)} />
                                </div>
                            </div>
                            <div className="col-12 main-input d-flex my-1 justify-content-start align-items-center">
                                <div className="profile-labels mb-auto mt-2"><label htmlFor="">Confirm</label></div>
                                <div className="profile-inputs-wrapper">
                                    <CustomInput blueborder={"true"} placeholder="Enter new password" value={passwordData?.confirm_password} name="confirm_password" onChange={(e) => handlePasswordForm(e)} />
                                </div>
                            </div>
                            <div className="col-12 mt-4"> <button className="light-btn password-btn">Update & Save</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            {/* ============================== */}
            {/* Calendar Model */}
            <CustomModel openPopup={openCalendar} setOpenPopup={setOpenCalendar} >
                <Calendar
                    className="cs-clander"
                    onChange={(item) => {
                        setOpenCalendar(false);
                        setData({
                            ...data,
                            birthdate: item
                        });
                    }}
                    date={getValid(data.birthdate)}
                />

            </CustomModel>
        </>
    )
}

export default ProfileUpdateForm;
